import HostConfig from 'commons/config/HostConfig';

const isProduction = process.env.NODE_ENV === 'production';

class HostFactory {
  private baseIP: string;
  private basePort?: string;
  private protocol: string;
  private contextPath?: string;
  private cloudfront: {
    protocol: string;
    baseURL: string;
  };

  constructor(config: KeyFlowHostConfig) {
    this.protocol = config.protocol;
    this.baseIP = config.ip;
    this.basePort = config.port;
    this.contextPath = config.contextPath;
    this.cloudfront = config.cloudfront;
  }

  get apiURL() {
    const contextPath = this.contextPath ? `/${this.contextPath}` : '';
    return `${this.protocol}://${this.baseIP}${contextPath}${
      this.basePort ? `:${this.basePort}` : ''
    }`;
  }
  get storageURL() {
    return `${this.protocol}://${this.baseIP}${this.basePort ? `:${this.basePort}` : ''}`;
  }
  get streamingURL() {
    return `${this.protocol}://${this.baseIP}${this.basePort ? `:${this.basePort}` : ''}`;
  }
  get cloudfrontURL() {
    return `${this.cloudfront.protocol}://${this.cloudfront.baseURL}`;
  }
}

export default new HostFactory(isProduction ? HostConfig.domain : HostConfig.dev);
